var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('user-stats-table',{attrs:{"value":_vm.stats}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }